import { MET_HOT_SUMMARY_ITEM, MET_HOT_DETAIL_ITEM } from './met-hot-items.js'

/** @type {import('../help-index.js').HelpScreen} */
export const MET_HOT_HELP = {
  screenId: 'met-hot',
  label: 'Hotel',
  navPath: 'Métricas → Hotel',
  keywords: ['ocupación hotel', 'adr', 'revpar', 'reservas'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Métricas de hotel: resumen de ocupación e ingresos y detalle por día.',
  sidebarItems: [MET_HOT_SUMMARY_ITEM, MET_HOT_DETAIL_ITEM],
}
